<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<frequently-asked-questions :items="faqs" />

		<contentblocks :items="page.contentblocks" />
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: faqs } = await useWebsiteFetch('frequentlyAskedQuestions', {
	query: { language: locale.value },
	key: `${locale.value}/frequentlyAskedQuestions`,
});

function stripHtml(html) {
	//eslint-disable-next-line
	if (typeof html !== 'string') return '';

	return html.replace(/<[^>]*>/g, '').trim();
}

useHead({
	script: [
		{
			type: 'application/ld+json',
			innerHTML: JSON.stringify({
				'@context': 'http://schema.org',
				'@type': 'FAQPage',
				mainEntity: faqs.value.flatMap((section) =>
					section.faqitems.map((item) => ({
						'@type': 'Question',
						name: item.question,
						acceptedAnswer: {
							'@type': 'Answer',
							text: stripHtml(item.answer),
						},
					})),
				),
			}),
		},
	],
});
</script>

<style lang="scss" scoped>
:deep(h1) {
	color: var(--tertiary-background-color);
}
</style>
